import React from "react";

const Contact = () => {
  return (
    <div className="container">
      <h2 className="text-center">Contact us</h2>
      <hr className="w-25 m-auto" />
      <div class="row m-5">
        <div class="col">
          <input
            type="text"
            class="form-control"
            placeholder="Name"
            aria-label="name"
          />
        </div>
        <div class="col">
          <input
            type="text"
            class="form-control"
            placeholder="Email"
            aria-label="email"
          />
        </div>
      </div>

      <div class="form-floating w-100">
        <textarea 
          class="form-control h-100"
          placeholder="Leave a comment here"
          id="floatingTextarea2"
        ></textarea>
        <label for="floatingTextarea2">Massage</label>
      </div>
      <button class="btn btn-primary mt-4 px-3" type="button">
        Send
      </button>
    </div>
  );
};

export default Contact;
